export default __webpack_public_path__ + "45c3eb00b262d29be16b2e6a0a9cb6dc.png";